import { render } from "./Column202309.vue?vue&type=template&id=265e97d9&scoped=true"
import script from "./Column202309.vue?vue&type=script&lang=js"
export * from "./Column202309.vue?vue&type=script&lang=js"

import "./Column202309.vue?vue&type=style&index=0&id=265e97d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-265e97d9"

export default script